import { createApp } from 'vue'
import Hello from '../components/Hello.vue'
import ModalManager from '../components/modals/ModalManager.vue'

// Grid system (Tabulator-based tables) — exposes window.PsGrids
import '../grids/bootstrap.js'

// Deck.gl Mapbox integration — exposes window.PsDeckMaps and window.deck.
// Bundles @deck.gl/{core,layers,extensions,mapbox} via Vite, replacing the
// earlier CDN script. Auto-installs the visgl/deck.gl#7326 shader patch on
// first patterned layer creation. See app/frontend/maps/deck/index.js.
import '../maps/deck/index.js'

// Block-analyzer lot-detail tab modules.
//   - selection.js exposes window.PsBlockAnalyzerSelection (shared store
//     used by both the embedded map and the Tabulator grid).
//   - map.js      exposes window.PsBlockAnalyzer (embedded map mount
//     function called from _detail.html.erb on tab activation).
import '../lot_detail/block_analyzer/selection.js'
import '../lot_detail/block_analyzer/map.js'

// Combine-lots super-combo modules.
//   - selection.js   exposes window.PsCombinedLots (singleton in-memory
//     store of shift-clicked BBLs + cached click-time geometries).
//   - map_overlay.js exposes window.PsCombinedLotsOverlay (deck.gl
//     dot-pattern overlay on the main super-combo map). Mount is called
//     from super_combo.html.erb after the main map's `load` event.
//   - data_loader.js exposes window.PsCombinedLotsDataLoader (per-BBL
//     cache + fetch from /lots/combined_lots_data, used by the phase-2
//     combined-lots Tabulator grid).
import '../super_combo/combined_lots/selection.js'
import '../super_combo/combined_lots/map_overlay.js'
import '../super_combo/combined_lots/data_loader.js'

console.log('Vite entry point loaded')

document.addEventListener('DOMContentLoaded', () => {
  const vueRoot = document.getElementById('vue-root')
  if (vueRoot) {
    console.log('Vue root element found')
    const app = createApp(Hello)
    app.mount('#vue-root')
  } else {
    console.log('Vue root element not found')
  }

  const modalRoot = document.getElementById('modal-root')
  if (modalRoot) {
    console.log('Modal root element found')
    const modalApp = createApp(ModalManager)
    const instance = modalApp.mount('#modal-root')   // ✅ correct way
    window.Modal = instance                           // ✅ instance === exposed values
    console.log('window.Modal =', window.Modal)
  }

})

const modals = import.meta.glob('/components/modals/**/*.vue')

window.lockScreen = function (blockMessage = 'Account locked') {
  const path = '/components/modals/AccountLockModal.vue'
  if (window.Modal && modals[path]) {
    modals[path]().then(({ default: Comp }) => {
      window.Modal.open(Comp, { blockMessage }, { blocking: true })
    })
  }
}
